
import axios from 'axios';
import consoleStyles from '@/utils/consoleStyles';
import store from "../store"

export default {
    async call( endpoint, requestParams = {}, config = {} ){

        config = {
            handle: 'handle' in config ? config.handle : false,
            cache: 'cache' in config ? config.cache : null,
        };

        console.log("%cApi Call » " + endpoint , consoleStyles.api );
        if( requestParams !== {} ){
            console.log("%cApi Params :", consoleStyles.apiData);
            console.table(requestParams);
        }

        let bodyFormData = new FormData();

        Object.keys(requestParams).forEach(key => {
            bodyFormData.append(key, requestParams[key]);
        });

        if( endpoint === 'fake'){
            return await new Promise(resolve => setTimeout(resolve, 1000));
        }

        let errorLog = '';
        let errorText = 'مشکلی در دریافت اطلاعات به وجود آمده است.';


        let apiUrl = store.state.api.url;

        try{
            //check if api cache exists
            if(config.cache !== null){

                const data = await store.dispatch('fetchApiCache', config.cache);

                if(data){
                    console.log("%cCache Response (for " + endpoint + ") : ", consoleStyles.cacheResponse);
                    console.table(data);
                    return data;
                }
            }

            //call api and fetch data
            const response = await axios.request({
                method: 'post',
                url: apiUrl + endpoint + '/',
                data: bodyFormData,
                headers: store.state.api.headers,
                timeout: store.state.api.timeout,
            });

            //check api response status
            if(response.status === 200){
                const data = response.data;

                console.log("%cApi Response (for " + endpoint + ") : ", consoleStyles.apiResponse);
                console.table(response.data);

                //set api cache
                if( data.success && config.cache !== null ){
                    store.dispatch('setApiCache', {
                        key: config.cache,
                        data: config.handle ? data : data.data
                    });
                }

                if(config.handle)
                    return data;

                if(!data.success){
                    if(data.data === 'noAccess'){
                        console.log('noAccess called');
                        store.dispatch('user/logoutUser', false);
                    }
                    store.dispatch('snack/showError', data.message);
                    return null;
                }

                return data.data === null ? true : data.data;

            }else{
                errorLog = response.status + " : " + response.statusText;
            }
        }catch (e) {
            errorLog = "«" + e.code + "» : " + e ;

            if(e.code === 'ECONNABORTED')
                errorText = 'اتصال به اینترنت را بررسی کنید.';

        }

        console.log("%cApi Response (for " + endpoint + ") : ", consoleStyles.apiResponseError);
        console.log("%c" + errorLog, consoleStyles.apiResponseError);

        store.dispatch('snack/showError', errorText);

        return null;
    },
};